import _ from 'lodash'
import { CasinoGameSection } from '@/components/casino/lobby/CasinoGameSection'
import { useLobbyCasinoGames } from '@/hooks/use-lobby-casino-games'
import { useAppDispatch } from '@/store/hooks'
import { setSelectedCasinoType } from '@/store/slices/casinoSlice'
import { BlackjackIcon } from '@/components/casino/icons'
import type { CasinoType } from '@/types/casino'

export function CasinoLobbyTypeSection({ type }: { type: CasinoType }) {
	const dispatch = useAppDispatch()
	const { games, isLoading, isLoadingMore, isError, hasMoreGames, loadMore } = useLobbyCasinoGames({
		type_id: type.id,
	})

	return (
		<CasinoGameSection
			title={_.capitalize(type.type_name)}
			icon={<BlackjackIcon className='h-7 w-7 text-subtle-foreground' />}
			games={games}
			isLoading={isLoading}
			isLoadingMore={isLoadingMore}
			isError={isError}
			hasMoreGames={hasMoreGames}
			onLoadMore={loadMore}
			onViewAll={() => dispatch(setSelectedCasinoType(type.id))}
			emptyMessage={`No ${type.type_name.toLowerCase()} games available right now.`}
		/>
	)
}
